import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Ban, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionGate({ children }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    if (user.is_super_admin) { setStatus({ status: "active" }); setLoading(false); return; }
    api.get("/subscription/status")
      .then((r) => setStatus(r.data))
      .catch(() => setStatus({ status: "active" }))
      .finally(() => setLoading(false));
  }, [user]);

  if (loading || !user) return children;
  if (!status) return children;

  // Blocco totale se sospeso
  if (status.status === "suspended") {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 p-4">
        <div className="max-w-md rounded-sm border-2 border-red-600 bg-white p-8 text-center shadow-2xl">
          <Ban className="mx-auto h-16 w-16 text-red-600" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">{t("auto.abbonamento_sospeso")}</h1>
          <p className="mt-2 text-sm text-slate-700">
            Il tuo abbonamento è stato sospeso.
            <br />
            <b>{t("auto.effettuare_il_pagamento_per_riprendere_ad_utilizzare_il_prog")}</b>
          </p>
          {status.suspend_reason && (
            <div className="mt-3 rounded-sm bg-red-50 p-2 text-xs text-red-900">
              Motivo: {status.suspend_reason}
            </div>
          )}
          {user.role === "admin" && (
            <Button
              onClick={() => nav("/abbonamento")}
              className="mt-6 rounded-sm bg-[#0052FF] hover:bg-[#0040CC]"
              data-testid="btn-goto-billing"
            >
              Vai al pagamento
            </Button>
          )}
          {user.role !== "admin" && (
            <p className="mt-4 text-xs text-slate-500">{t("auto.contatta_lamministratore_della_tua_azienda")}</p>
          )}
        </div>
      </div>
    );
  }

  // Warning banner per past_due o trial in scadenza
  const showWarning = status.warning || status.status === "past_due";
  return (
    <>
      {showWarning && (
        <div className="mb-3 flex items-start gap-2 rounded-sm border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="subscription-warning-banner">
          <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <div className="flex-1">
            <b>{status.status === "past_due" ? "Pagamento non riuscito — " : ""}{status.warning || "L'abbonamento richiede attenzione"}</b>
            {user.role === "admin" && (
              <button onClick={() => nav("/abbonamento")} className="ml-2 underline">Vai al pagamento →</button>
            )}
          </div>
        </div>
      )}
      {children}
    </>
  );
}
